module.exports = __webpack_public_path__ + "static/77a4ff4c95c9d41331e34d5b15e43004e44c211139517ba36cceda64aa3dcb41-be790ad062f58adbbd149373dfd3a9b6.svg";